import * as moment from 'moment';
import { Trip } from '../Trip/Trip';
export class Destination{

    resolvesTo:string;
    lat:number;
    lng:number;
    person:string;
    time:string;
    employeeid:any;

    constructor(lat,lng,person,time){

        this.lat = lat;
        this.lng = lng;
        this.person = person;
        this.time = time ? Trip.createSubTripKey(moment(new Date(time))) : null
    }
}